import { Injectable } from '@angular/core';
import { Incompatibilities } from '../Incompatibilities';
import { Cpu } from '../model/Cpu';
import { Mother } from '../model/Mother';
import { FuncionCompatilibidadBase } from './FuncionesCompatibilidadBase';
import { IncompatibilitiesType } from '@core/enums/incompatibilities-types.enum';

@Injectable({
  providedIn: 'root',
})
export class FC_CpuMother extends FuncionCompatilibidadBase<Cpu, Mother> {
  funciones = {
    socket: (cpu: Cpu, mother: Mother): Incompatibilities | null => {
      return !mother.$caracteristicas.cpus.split(',').includes(cpu.$caracteristicas.tipo) ?
          {
            tipo: IncompatibilitiesType.PRODUCTO,
            incompatibility: `El socket ${cpu.$caracteristicas.tipo} del cpu no es compatible con la mother`,
          }
        : null;
    },
    subcategoria: (cpu: Cpu, mother: Mother): Incompatibilities | null => {
      let subcategoriaValida = mother.id_subcategoria == 26 ? 27 : 48;
      return cpu.id_subcategoria != subcategoriaValida ?
          {
            tipo: IncompatibilitiesType.PRODUCTO,
            incompatibility: `El cpu ${
              cpu.id_subcategoria == 27 ? 'AMD' : 'Intel'
            } no es compatible con la mother ${mother.id_subcategoria == 26 ? 'AMD' : 'Intel'}`,
          }
        : null;
    },
  };
}
